const TAB_ID_STORAGE_KEY = "tabId";
export const TAB_AWARE_SOCKET_VERSION = "2";

const createPageInstanceId = () => {
  const randomId =
    typeof globalThis.crypto?.randomUUID === "function"
      ? globalThis.crypto.randomUUID()
      : `${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;

  return `tmatab_${randomId}`;
};

const pageInstanceId = createPageInstanceId();

try {
  globalThis.sessionStorage?.setItem(TAB_ID_STORAGE_KEY, pageInstanceId);
} catch {
  // The in-memory ID still keeps Axios and WebSocket aligned.
}

export const getPageInstanceId = () => pageInstanceId;
